// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1rP9O","inner":"Header_inner__rFKIW","subtitle":"Header_subtitle__32e_B","logo":"Header_logo__3vt6J","search":"Header_search__YdXNU"};